/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const downloadResult =
  (defaultFileName: string, fileType: string) =>
  (source: Observable<HttpResponse<ArrayBuffer | Blob>>): Observable<true | undefined> =>
    source.pipe(
      map((response) => {
        if (!response.body) return;
        const match = response.headers.get('Content-Disposition')?.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        const filename = match ? (match[1] ?? defaultFileName) : defaultFileName;
        const blob = new Blob([response.body], { type: fileType });
        const downloadUrl = URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = filename;

        a.click();

        setTimeout(() => URL.revokeObjectURL(downloadUrl), 100);

        return true;
      }),
    );
